"use strict";

exports.__esModule = true;
exports.default = void 0;
var _reactEmotion = _interopRequireDefault(require("react-emotion"));
var _base = _interopRequireDefault(require("../../shared/base"));
var _font = _interopRequireDefault(require("../../shared/font"));
var _H = require("./H1");
var _mediaQueries = _interopRequireDefault(require("../../shared/mediaQueries"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var H3 = /*#__PURE__*/
(0, _reactEmotion.default)('h3', {
  target: "edos9m30"
})(_base.default, ";", _font.default, ";", _H.text, ";font-size:", function (props) {
  return props.fontSize || '1.5rem';
}, ";line-height:", function (props) {
  return props.lineHeight || '2.065rem';
}, ";font-weight:", function (props) {
  return props.fontWeight || 'normal';
}, ";text-align:", function (props) {
  return props.center ? 'center' : 'inherit';
}, ";", (0, _mediaQueries.default)('md'), "{font-size:1.125rem;line-height:1.5rem;}");
var _default = H3;
exports.default = _default;